import { selector } from 'recoil';
import ordersAtom from '~/recoil/atom/orders';
import cartTypeAtom from '~/recoil/atom/cartType';
import itemsTotalPerStoreMapSelector from '~/recoil/selectors/itemsTotalPerStoreMap';
import couponAtom from '~/recoil/atom/coupon';

import * as fp from 'lodash/fp';
import { CartItem, CartType } from '~/types/cart';
import getDiscountFn from '~/utils/getDiscountFn';
import enterpriseGroupBuyOrdersAtom from '../atom/enterpriseGroupBuy/enterpriseGroupBuyOrders';
import globalEnterpriseGroupBuyAtom from '../atom/enterpriseGroupBuy/globalEnterpriseGroupBuyAtom';

const cartSettlement = selector<{
  itemAmount: number;
  coupon: number;
  subtotal: number;
  total: number;
}>({
  key: 'cartSettlement',
  get: ({ get }) => {
    const cartType = get(cartTypeAtom);
    const { data = null } = get(globalEnterpriseGroupBuyAtom);
    const orders = get(!!data ? enterpriseGroupBuyOrdersAtom : ordersAtom);
    const itemsTotalPerStoreMap = get(itemsTotalPerStoreMapSelector);
    const coupon = !!data ? null : get(couponAtom);

    const orderItems =
      cartType === CartType.CART_PERSONAL
        ? orders.flatMap(fp.propOr([], 'items'))
        : orders.flatMap(({ groupItems }) => groupItems.flatMap(fp.propOr([], 'items')));

    const subtotal = fp.sum([...itemsTotalPerStoreMap.values()]);

    const couponDiscountAmount = coupon
      ? getDiscountFn({ type: coupon.type, condition: coupon.condition })(
          fp.sum(coupon.stores.map((id) => itemsTotalPerStoreMap.get(id) || 0)),
        )
      : 0;

    return {
      itemAmount: fp.sumBy<CartItem>(fp.prop('count'))(orderItems),
      coupon: couponDiscountAmount,
      subtotal,
      total: subtotal - couponDiscountAmount,
    };
  },
});

export default cartSettlement;
